@if (ppWorkspaces && ppWorkspaces.length > 0) {
  <table aria-label="User sites table" class="settingsTable">
    <thead class="settingsTable__head">
      <tr class="userSettingsTable__header-row">
        <th scope="col" class="settingsTable__header">
          {{ 'site' | ppTranslate }}
        </th>
        <th scope="col" class="settingsTable__header userSettingsTable__hide-site">
          {{ 'hide_site' | ppTranslate }}
        </th>
        <th scope="col" class="settingsTable__header userSettingsTable__access">
          {{ 'access' | ppTranslate }}
        </th>
        <th scope="col" class="settingsTable__header userSettingsTable__notification-header">
          {{ 'email_notification' | ppTranslate }}
        </th>
      </tr>
    </thead>
    <tbody class="settingsTable__body">
      @for (workspace of workspaces; track workspace; let i = $index) {
        <tr class="userSettingsTable__row">
          <td class="settingsTable__multirow settingsTable__cell">
            <p class="settingsTable__multirow-top">
              {{ workspace.name }}
            </p>
            <p class="settingsTable__multirow-bottom">
              {{ workspace.accountName }}
            </p>
          </td>
          <td class="settingsTable__cell userSettingsTable__hide-site">
            <pp-icon
              data-test="settingsTable_tooltip_icon"
              ppTooltip
              [ppTitle]="
                (workspace.hidden ? 'custom_field_hidden_tooltip' : 'custom_field_visible_tooltip')
                  | ppTranslate
              "
              [ppSrc]="
                workspace.hidden
                  ? EIconPath.ICON_USER_GROUPS_HIDDEN_24
                  : EIconPath.ICON_USER_GROUPS_VISIBLE_24
              "
              ppClass="setSize24"
              ppColor="grey-900"
              (click)="toggleSiteHidden(workspace)"
              class="userSettingsTable__hide-site-icon"
            />
          </td>
          <td class="settingsTable__cell userSettingsTable__access">
            {{ shareOptionLabels[workspace?.shareOption] }}
          </td>
          <td class="userSettingsTable__notifications settingsTable__cell">
            <ng-container>
              {{
                subscriptionsById.data[workspace.workspaceId]?.subscriptionType
                  ? (notificationLabels[
                      subscriptionsById.data[workspace.workspaceId]?.subscriptionType
                    ] | ppTranslate)
                  : ('notification_none' | ppTranslate)
              }}
            </ng-container>
            <pp-edit-button
              (ppAction)="editNotifications(workspace)"
              ppId="editNotificationsBtn"
              data-m-target="Edit notifications button"
              class="userSettingsTable__notifications-btn"
              [ppNoText]="true"
            ></pp-edit-button>
          </td>
        </tr>
      }
    </tbody>
  </table>
}
